export default {
  case: '判案书',
  legis: '法例',
  other: '其他',
  regulations: '附属法例',
  ordinances: '条例',
}